import React from "react";
import { withRouter } from "react-router-dom";
import Reveal from 'react-reveal/Reveal';

import Footer from '../components/Footer';

import { Efect, Efect1, Efect2  } from "../styles/effect.styles";
  

const About = ({ history }) => {

  return (
    <div>
      <Efect/>
      <Efect1/>
      <Efect2/>

      <div className="jumbotron head"/>

      <Reveal effect="fadeIn">
        <section className='jumbotron imgtop'>
        	<img
	          src="./img/Services.png"
	          className="img-fluid"
	          alt="#"
	        />
        </section>
       </Reveal>
        
       <Reveal effect="fadeIn">
       <section className='container-fluid pb-0'>
        <div><h1>Services</h1></div>
       </section>
       </Reveal>

      <Reveal effect="fadeIn">
        <section className='container-fluid pb-0'>
	        <div className='row m-2-hor'>
	        	<div className='col-md-4'>
	        		<h1> <span style={{color: '#92ADA4' }}>Naturopathic Medicine</span></h1>
	        	</div>
	        	<div className='col-md-8'>
	        		<div className='content'>
                <div>Naturopathic medicine is a holistic system of healthcare that blends modern scientific medical knowledge with traditional and natural therapies to support the body’s innate ability to heal. Rooted in the principles of treating the whole person and addressing the root cause of illness, naturopathic care emphasizes prevention, individualized treatment, and long-term wellness. </div> 
                <div> <span style={{ color: 'white' }}>.</span> </div>
                <div>Dr. Michelle’s approach to naturopathic medicine is grounded in a deep understanding of the interconnectedness of the body and mind—especially when it comes to supporting females, athletes, and active individuals. She recognizes that before you are an athlete, you are a whole person with unique physiological and psychological needs. Since training, performance, and competition place stress on multiple systems of the body, Michelle believes that optimizing overall health is essential to achieving peak performance and recovery.</div>
                <div> <span style={{ color: 'white' }}>.</span> </div>
                <div>Services included in Naturopathic Care may include:</div>
              <ul className='list-home'>
              <li>Functional Blood Testing</li>
               <li>Comprehensive bloodwork review & analysis</li>  
               <li>Nutrition & Lifestyle programming</li>
               <li>Customized supplement protocols</li>
               <li>Botanical Medicine</li>
               <li>Homeopathy</li>
               <li>Acupuncture</li>
               <li>IV Nutritional Therapy</li>
               <li>Hormonal Replacement Therapy</li>
               <li>Pharmaceutical Presciptions</li>
              </ul>
	        		</div>
	        	</div>
	        </div>
	    </section>
	   </Reveal>

      <Reveal effect="fadeIn">
        <section className='container-fluid pb-0'>
	        <div className='row m-2-hor'>
	        	<div className='col-md-4'>
	        		<h1> <span style={{color: '#92ADA4' }}>Holistic Health Coaching</span></h1>
	        	</div>
	        	<div className='col-md-8'>
	        		<div className='content'> 
                <div>Dr. Michelle offers personalized virtual Health & Wellness Coaching programs designed to support individuals in achieving vibrant, sustainable well-being—no matter where you live! Rooted in naturopathic principles, this whole-person approach focuses on balancing hormones, enhancing recovery, improving energy, and optimizing daily habits to help you feel empowered, aligned, and thriving in your everyday life.</div>
                <div> <span style={{ color: 'white' }}>.</span> </div>
                <div>Whether you're navigating hormonal changes, training as an athlete, or recovering from injury, you'll work together to create a plan that supports your body’s unique needs. Choose from 3-, 6-, or 9-month programs tailored to your goals.</div>
                <div> <span style={{ color: 'white' }}>.</span> </div>
                <div>Each Hollistic Health Coaching program includes:</div>
	        		
              <ul className='list-home'>
              <li>Comprehensive bloodwork review & analysis</li>  
              <li>Personalized diet plans with grocery lists and recipes for every meal and snack of your days</li>
              <li>Structured weekly exercise plans with video demonstrations to target your body's specific needs whether that be rehabilitation, mobility exercises, and/or strengthening exercises</li>
              <li>Customized supplement protocol, outlining what to take, when, and how</li>
              <li>30-minute weekly check-ins to reassess the protocol and adjust anything that may be necessary</li>
              </ul>
              </div>  
	        	</div>
            <div> <span style={{ color: 'white' }}>.</span> </div>

            <a
  href="https://drmichellendstudeogyms.janeapp.com/"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-block",
    margin: "2rem 0 1rem",
    padding: "0.75rem 1.5rem",
    border: "2px solid #FED8A6",
    color: "#DAA38F",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "bold",
    backgroundColor: "transparent",
    transition: "all 0.3s ease",
  }}
  onMouseOver={(e) => {
    e.target.style.backgroundColor = "#92ADA4";
    e.target.style.color = "#fff";
  }}
  onMouseOut={(e) => {
    e.target.style.backgroundColor = "transparent";
    e.target.style.color = "#DAA38F";
  }}
>
  Book Now
</a>

            <div>Disclaimer: Naturopathic Medical Services are only available to residents of California & British Columbia. Holistic Wellness Coaching is available to all individuals, however it is not a substitute for medical care and does not include diagnosis, treatment, or prescription. </div>
	        </div>
	    </section>
	   </Reveal> 

      <Footer />

    </div>
    
  );
};

export default withRouter(About);